/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';


import BootstrapDialog from 'bootstrap3-dialog/dist/js/bootstrap-dialog';


class worspaceModel {

    constructor() {
        // Profile
        this.componentName = "workspace";
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(false);

        //Modal
        this.modalTitle = ko.observable("");
        this.modalBody = ko.observable("");
        this.modalHeadCss = ko.observable("");
        this.modalBodyCss = ko.observable("");

        this.context.eventManager.subscribe((loginStatusObj) =>{
            this.handleModalLoginStatus(loginStatusObj);
        },this, "loginStatus");

        this.context.eventManager.subscribe((modalObj) =>{
            this.handleModalRequest(modalObj);
        },this, "messageModel");

        ko.components.register('workspace-nav', require('../workspace-nav/workspace-nav').default);

        ko.components.register('nav-home', require('../nav-home/nav-home').default);
        ko.components.register('nav-job-list', require('../nav-job-list/nav-job-list').default);
        ko.components.register('nav-options', require('../nav-options/nav-options').default);

    }

    handleModalLoginStatus(loginStatusObj) {
        
        console.log("worspaceModel:handleModalLoginStatus");
        console.log(loginStatusObj.Complete);

        if((loginStatusObj.Complete) && ((loginStatusObj.Mode == 'Standard') || (loginStatusObj.Mode == 'StandAlone')) )
        {
            this.visible(true);
        }

    }

    handleModalRequest(modalObj) {
        console.log("Workspace:handleModalRequest");
        this.modalTitle(modalObj.modalTitle);
        this.modalBody(modalObj.modalBody);

        let messageType = BootstrapDialog.TYPE_WARNING;

        if(modalObj.modalTitle.indexOf("Error") !== -1)
        {
            console.log("Sending Error to Sentry");
            messageType = BootstrapDialog.TYPE_DANGER;
            //this.context.Raven.setExtraContext(this.context);
            this.context.Raven.setUserContext({id: this.context.subid() });
            this.context.Raven.captureMessage(modalObj.modalBody, { level: 'error'});
        }

        //$('#messageModal').modal('show');

        let temp = new BootstrapDialog.show({
            type: messageType,
            title: modalObj.modalTitle,
            message: modalObj.modalBody,
            buttons: [{
                label: 'Close',
                action: function(dialogRef){
                    dialogRef.close();
                }
            }]
        });
    }

}

export default { viewModel: worspaceModel, template: require('!raw-loader!./workspace.html') };



// WEBPACK FOOTER //
// ./src/components/workspace/workspace.js